'use client';
import { InlineNotification } from '@mv/web-ui';
import React from 'react';

type WarningBlockProps = {
	children: React.ReactNode;
	resetKey?: string | number;
};

type WarningBlockState = {
	hasError: boolean;
	error?: Error;
};

class WarningBlock extends React.Component<WarningBlockProps, WarningBlockState> {
	constructor(props: WarningBlockProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error): WarningBlockState {
		return { hasError: true, error };
	}

	componentDidUpdate(prevProps: WarningBlockProps) {
		if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
			this.setState({ hasError: false, error: undefined });
		}
	}

	render() {
		if (this.state.hasError) {
			return (
				<InlineNotification data-component="WarningBlock" type="warning">
					<p>Oops! Something went wrong while rendering this block. Make sure all required fields are filled in.</p>
				</InlineNotification>
			);
		}
		return this.props.children;
	}
}

export default WarningBlock;
